import {
    Container,
    Typography,
    Box,
    Stack,
    Button
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import MockData from "../../helper/MockData";
import SchoolLeaderboardDisplay from "../../sections/schooLeaderboard/SchoolLeaderboardDisplay";
import SchoolLeaderboardSlideDisplay from "../../sections/schooLeaderboard/SchoolLeaderboardSlideDisplay";

export default function TestTestSchoolLeaderboardDisplaySimple() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);
    const [leaderboardData, setLeaderboardData] = React.useState(null);


    React.useEffect(() => {
        let data = MockData.getAllSkillLeaderboard();
        setLeaderboardData(data);
    }, []);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // let leaderboardData = MockData.getAllSkillLeaderboard();

    let filters = {
        dateRangeType: "semester",
        year: 2024,
    }

    let firstLeaderboard = leaderboardData?.[0] || {};
    // setValue(1234);

    let sliderSetting = {
        interval: 3000,
    }

    let changeDataSet = () => {
        let newDataSet = MockData.getAllSkillLeaderboardDataSet2();
        setLeaderboardData(newDataSet);
        console.log("changeDataSet: ", leaderboardData);
        ///   setValue(value + 1);
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Leaderboard Display</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>

                    <Button variant="contained" onClick={changeDataSet}>Change Data Set</Button>


                    {
                        leaderboardData == null &&
                        <Typography variant="h6">Loading data...</Typography>
                    }

                    {
                        leaderboardData != null &&
                        <SchoolLeaderboardSlideDisplay
                            leaderboardList={leaderboardData}
                            filters={filters}
                            sliderSetting={sliderSetting}
                        />
                    }

                    {/* <SchoolLeaderboardDisplay
                        leaderboardData={firstLeaderboard} 
                        filters={filters}
                    /> */}
                    <pre>
                        {
                            JSON.stringify(leaderboardData, null, 2)
                        }
                    </pre>
                </Box>
            </Stack>
        </Container>
    )
}
